/*
 * Os desenhos do Lucide de todos os nomes do mapa (iconMap.ts): os ícones de
 * interface e os que um admin pode escolher para tags e grupos (foguete,
 * troféu, paleta…), que também viram Lucide.
 *
 * Tudo no pacote principal, de propósito: com os desenhos num chunk sob
 * demanda, o primeiro desenho sairia no Font Awesome e as partes que o Flarum
 * congela (o SubtreeRetainer dos itens da lista) nunca trocariam pelo Lucide.
 * Só os ícones importados por nome entram no pacote (o lucide declara
 * `sideEffects: false`, então o webpack descarta os outros ~3.500).
 *
 * O lucide está fixado na 0.555.0: a 1.x redesenhou dezenas de ícones. Os
 * poucos desenhos que o tema quer na versão anterior vêm escritos à mão no
 * fim da tabela.
 *
 * Lucide (https://lucide.dev), licença ISC. Copyright (c) for portions of
 * Lucide are held by Cole Bemis 2013-2022 as part of Feather (MIT). All other
 * copyright (c) for Lucide are held by Lucide Contributors 2022. Permission to
 * use, copy, modify, and/or distribute this software for any purpose with or
 * without fee is hereby granted, provided that the above copyright notice and
 * this permission notice appear in all copies. THE SOFTWARE IS PROVIDED "AS
 * IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE.
 */

import { Accessibility, ChevronsUpDown, Ambulance, Angry, Archive, ArrowDown, ArrowLeft, ArrowLeftFromLine, ArrowLeftRight, ArrowRight, ArrowRightFromLine, ArrowUp, ArrowUpDown, Asterisk, AtSign, Award, Ban, Bed, Bell, BellRing, BellDot, BellOff, Bold, Book, BookOpen, BookOpenText, BookUser, Bookmark, BookmarkX, Bot, Boxes, Briefcase, Cake, Calendar, CalendarDays, CalendarPlus, ChartBar, ChartColumn, ChartLine, ChartPie, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Circle, CircleAlert, CircleCheck, CircleChevronDown, CircleDot, CircleHelp, CircleMinus, CirclePlus, CircleQuestionMark, CircleStop, CircleUser, CircleX, Clipboard, Clock, CloudDownload, CloudUpload, Code, Columns2, Copy, Copyright, CreditCard, Crosshair, Crown, Cuboid, Download, Ellipsis, EllipsisVertical, Eraser, ExternalLink, Eye, EyeOff, FastForward, Feather, FileArchive, FileCode, FileImage, FileOutput, FilePen, FileSpreadsheet, FileUp, FileVideo, FileVolume, Flag, Flame, FlaskConical, Folder, FolderOpen, Frown, Funnel, FunnelX, Gavel, Gift, GitBranch, Globe, GraduationCap, Grid2x2, Grid3x3, GripHorizontal, GripVertical, Hand, Handshake, Hash, HatGlasses, Heading, Headset, Heart, Hourglass, IdCard, Image, Inbox, Info, Italic, Key, Keyboard, Languages, Laptop, Layers, Lightbulb, Link, Link2Off, List, Loader, Lock, LockKeyholeOpen, LockOpen, LogIn, LogOut, Mail, MailOpen, MapPin, Maximize, Medal, Megaphone, Meh, MessageCircle, MessageCircleMore, MessageCircleOff, MessageSquare, MessageSquareText, MessagesSquare, MicOff, Minimize, Minus, Monitor, Moon, Paintbrush, Palette, Pen, Pencil, PencilRuler, Pin, PinOff, Pipette, Play, Plug, Plus, PowerOff, Printer, Puzzle, Quote, RefreshCcw, Repeat, Reply, ReplyAll, Rewind, Rocket, RotateCcw, RotateCw, Rss, Save, Scroll, Search, Send, Settings, Share, Share2, Shield, ShieldHalf, ShieldUser, Shuffle, Signal, SkipBack, SkipForward, Smartphone, Smile, SpellCheck, Square, SquareCheck, SquarePen, SquarePlus, SquareTerminal, Stamp, Star, StepBack, StickyNote, Strikethrough, Sun, Table, Tag, Tags, Target, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Trash, TriangleAlert, Trophy, Type, Upload, User, UserCheck, UserCog, UserMinus, UserPen, UserPlus, UserX, Users, Volume2, VolumeX, Server, Vote, WandSparkles, Workflow, Wrench, X, ZoomIn, ZoomOut } from 'lucide';
export const GLYPHS = {
  accessibility: Accessibility,
  'chevrons-up-down': ChevronsUpDown,
  server: Server,
  ambulance: Ambulance,
  angry: Angry,
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-left-from-line': ArrowLeftFromLine,
  'arrow-left-right': ArrowLeftRight,
  'arrow-right': ArrowRight,
  'arrow-right-from-line': ArrowRightFromLine,
  'arrow-up': ArrowUp,
  'arrow-up-down': ArrowUpDown,
  asterisk: Asterisk,
  'at-sign': AtSign,
  award: Award,
  ban: Ban,
  bed: Bed,
  bell: Bell,
  'bell-ring': BellRing,
  'bell-dot': BellDot,
  'bell-off': BellOff,
  bold: Bold,
  book: Book,
  'book-open': BookOpen,
  'book-open-text': BookOpenText,
  'book-user': BookUser,
  bookmark: Bookmark,
  'bookmark-x': BookmarkX,
  bot: Bot,
  boxes: Boxes,
  briefcase: Briefcase,
  cake: Cake,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  'calendar-plus': CalendarPlus,
  'chart-bar': ChartBar,
  'chart-column': ChartColumn,
  'chart-line': ChartLine,
  'chart-pie': ChartPie,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-down': ChevronsDown,
  'chevrons-left': ChevronsLeft,
  'chevrons-right': ChevronsRight,
  'chevrons-up': ChevronsUp,
  circle: Circle,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-chevron-down': CircleChevronDown,
  'circle-dot': CircleDot,
  'circle-help': CircleHelp,
  'circle-minus': CircleMinus,
  'circle-plus': CirclePlus,
  'circle-question-mark': CircleQuestionMark,
  'circle-stop': CircleStop,
  'circle-user': CircleUser,
  'circle-x': CircleX,
  clipboard: Clipboard,
  clock: Clock,
  'cloud-download': CloudDownload,
  'cloud-upload': CloudUpload,
  code: Code,
  'columns-2': Columns2,
  copy: Copy,
  copyright: Copyright,
  'credit-card': CreditCard,
  crosshair: Crosshair,
  crown: Crown,
  cuboid: Cuboid,
  download: Download,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  eraser: Eraser,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  'fast-forward': FastForward,
  feather: Feather,
  'file-archive': FileArchive,
  'file-code': FileCode,
  'file-image': FileImage,
  'file-output': FileOutput,
  'file-pen': FilePen,
  'file-spreadsheet': FileSpreadsheet,
  'file-up': FileUp,
  'file-video': FileVideo,
  'file-volume': FileVolume,
  flag: Flag,
  flame: Flame,
  'flask-conical': FlaskConical,
  folder: Folder,
  'folder-open': FolderOpen,
  frown: Frown,
  funnel: Funnel,
  'funnel-x': FunnelX,
  gavel: Gavel,
  gift: Gift,
  'git-branch': GitBranch,
  globe: Globe,
  'graduation-cap': GraduationCap,
  'grid-2x2': Grid2x2,
  'grid-3x3': Grid3x3,
  'grip-horizontal': GripHorizontal,
  'grip-vertical': GripVertical,
  hand: Hand,
  handshake: Handshake,
  hash: Hash,
  'hat-glasses': HatGlasses,
  heading: Heading,
  headset: Headset,
  heart: Heart,
  hourglass: Hourglass,
  'id-card': IdCard,
  image: Image,
  inbox: Inbox,
  info: Info,
  italic: Italic,
  key: Key,
  keyboard: Keyboard,
  languages: Languages,
  laptop: Laptop,
  layers: Layers,
  lightbulb: Lightbulb,
  link: Link,
  'link-2-off': Link2Off,
  list: List,
  loader: Loader,
  lock: Lock,
  'lock-keyhole-open': LockKeyholeOpen,
  'lock-open': LockOpen,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  'mail-open': MailOpen,
  'map-pin': MapPin,
  maximize: Maximize,
  medal: Medal,
  megaphone: Megaphone,
  meh: Meh,
  'message-circle': MessageCircle,
  'message-circle-more': MessageCircleMore,
  'message-circle-off': MessageCircleOff,
  'message-square': MessageSquare,
  // O balão do chat (aba de chat do menu do usuário).
  'message-square-text': MessageSquareText,
  'messages-square': MessagesSquare,
  'mic-off': MicOff,
  minimize: Minimize,
  minus: Minus,
  monitor: Monitor,
  moon: Moon,
  paintbrush: Paintbrush,
  palette: Palette,
  pen: Pen,
  pencil: Pencil,
  'pencil-ruler': PencilRuler,
  pin: Pin,
  'pin-off': PinOff,
  pipette: Pipette,
  play: Play,
  plug: Plug,
  plus: Plus,
  'power-off': PowerOff,
  printer: Printer,
  puzzle: Puzzle,
  quote: Quote,
  'refresh-ccw': RefreshCcw,
  repeat: Repeat,
  reply: Reply,
  'reply-all': ReplyAll,
  rewind: Rewind,
  rocket: Rocket,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  rss: Rss,
  save: Save,
  scroll: Scroll,
  search: Search,
  send: Send,
  settings: Settings,
  share: Share,
  'share-2': Share2,
  shield: Shield,
  'shield-half': ShieldHalf,
  'shield-user': ShieldUser,
  shuffle: Shuffle,
  signal: Signal,
  'skip-back': SkipBack,
  'skip-forward': SkipForward,
  smartphone: Smartphone,
  smile: Smile,
  'spell-check': SpellCheck,
  square: Square,
  'square-check': SquareCheck,
  'square-pen': SquarePen,
  'square-plus': SquarePlus,
  'square-terminal': SquareTerminal,
  stamp: Stamp,
  star: Star,
  'step-back': StepBack,
  strikethrough: Strikethrough,
  'sticky-note': StickyNote,
  sun: Sun,
  table: Table,
  tag: Tag,
  tags: Tags,
  target: Target,
  thermometer: Thermometer,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  'toggle-left': ToggleLeft,
  'toggle-right': ToggleRight,
  trash: Trash,
  'triangle-alert': TriangleAlert,
  trophy: Trophy,
  type: Type,
  upload: Upload,
  user: User,
  'user-check': UserCheck,
  'user-cog': UserCog,
  'user-minus': UserMinus,
  'user-pen': UserPen,
  'user-plus': UserPlus,
  'user-x': UserX,
  users: Users,
  'volume-2': Volume2,
  'volume-x': VolumeX,
  vote: Vote,
  'wand-sparkles': WandSparkles,
  workflow: Workflow,
  wrench: Wrench,
  x: X,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  // Desenhos escritos à mão: o lucide@0.555.0 já traz a versão revista destes.
  'align-left': [['path', {
    d: 'M15 12H3'
  }], ['path', {
    d: 'M17 18H3'
  }], ['path', {
    d: 'M21 6H3'
  }]],
  anchor: [['path', {
    d: 'M12 22V8'
  }], ['path', {
    d: 'M5 12H2a10 10 0 0 0 20 0h-3'
  }], ['circle', {
    cx: '12',
    cy: '5',
    r: '3'
  }]],
  file: [['path', {
    d: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z'
  }], ['path', {
    d: 'M14 2v4a2 2 0 0 0 2 2h4'
  }]],
  'file-text': [['path', {
    d: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z'
  }], ['path', {
    d: 'M14 2v4a2 2 0 0 0 2 2h4'
  }], ['path', {
    d: 'M10 9H8'
  }], ['path', {
    d: 'M16 13H8'
  }], ['path', {
    d: 'M16 17H8'
  }]],
  house: [['path', {
    d: 'M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8'
  }], ['path', {
    d: 'M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'
  }]],
  images: [['path', {
    d: 'm22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16'
  }], ['path', {
    d: 'M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2'
  }], ['circle', {
    cx: '13',
    cy: '7',
    r: '1',
    fill: 'currentColor'
  }], ['rect', {
    width: '12',
    height: '12',
    x: '8',
    y: '2',
    rx: '2'
  }]],
  'list-check': [['path', {
    d: 'M11 18H3'
  }], ['path', {
    d: 'm15 18 2 2 4-4'
  }], ['path', {
    d: 'M16 12H3'
  }], ['path', {
    d: 'M16 6H3'
  }]],
  'list-ordered': [['path', {
    d: 'M10 12h11'
  }], ['path', {
    d: 'M10 18h11'
  }], ['path', {
    d: 'M10 6h11'
  }], ['path', {
    d: 'M4 10h2'
  }], ['path', {
    d: 'M4 6h1v4'
  }], ['path', {
    d: 'M6 18H4c0-1 2-2 2-3s-1-1.5-2-1'
  }]],
  menu: [['path', {
    d: 'M4 12h16'
  }], ['path', {
    d: 'M4 18h16'
  }], ['path', {
    d: 'M4 6h16'
  }]],
  pause: [['rect', {
    width: '4',
    height: '16',
    x: '14',
    y: '3',
    rx: '1'
  }], ['rect', {
    width: '4',
    height: '16',
    x: '5',
    y: '3',
    rx: '1'
  }]],
  'sliders-horizontal': [['line', {
    x1: '21',
    x2: '14',
    y1: '4',
    y2: '4'
  }], ['line', {
    x1: '10',
    x2: '3',
    y1: '4',
    y2: '4'
  }], ['line', {
    x1: '21',
    x2: '12',
    y1: '12',
    y2: '12'
  }], ['line', {
    x1: '8',
    x2: '3',
    y1: '12',
    y2: '12'
  }], ['line', {
    x1: '21',
    x2: '16',
    y1: '20',
    y2: '20'
  }], ['line', {
    x1: '12',
    x2: '3',
    y1: '20',
    y2: '20'
  }], ['line', {
    x1: '14',
    x2: '14',
    y1: '2',
    y2: '6'
  }], ['line', {
    x1: '8',
    x2: '8',
    y1: '10',
    y2: '14'
  }], ['line', {
    x1: '16',
    x2: '16',
    y1: '18',
    y2: '22'
  }]]
};
flarum.reg.add('ramon-canela', 'forum/icons/glyphs', { GLYPHS: GLYPHS, });